import { SVGProps } from "react"
const RentalHousingFormErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.7252 48.1718C56.0752 52.222 52.222 56.0752 48.1719 54.7251L8.54289 41.5155C4.12866 40.0441 3.7413 33.9511 7.93368 31.9325L22.2479 25.0405C23.4683 24.4529 24.4531 23.4682 25.0407 22.2477L31.9326 7.9337C33.9511 3.74132 40.0441 4.12863 41.5155 8.54289L54.7252 48.1718ZM49.4321 50.9444C50.3668 51.2559 51.256 50.3667 50.9444 49.4321L37.7348 9.80315C37.3952 8.78448 35.9891 8.69509 35.5233 9.66257L28.6314 23.9766C28.4355 24.3836 28.213 24.7748 27.9662 25.1482L38.9907 36.1727C39.7689 36.9509 39.7689 38.2126 38.9907 38.9907C38.2125 39.7689 36.9508 39.7689 36.1727 38.9907L25.1481 27.9662C24.7748 28.2129 24.3837 28.4353 23.9768 28.6312L9.66256 35.5233C8.69509 35.9891 8.78447 37.3952 9.80315 37.7347L49.4321 50.9444Z"
        fill={props.color || "#C92418"}
      />
    </svg>
  )
}

export default RentalHousingFormErrorIcon
